export const mockGatsbyImageData = {
  layout: 'constrained' as const,
  width: 400,
  height: 400,
  images: {
    sources: [],
    fallback: {
      src: 'https://i.pinimg.com/736x/47/2a/f3/472af31c213e33763a9000475e8b2a55.jpg',
      srcSet: 'https://i.pinimg.com/736x/47/2a/f3/472af31c213e33763a9000475e8b2a55.jpg 400w',
      sizes: '(max-width: 400px) 100vw, 400px'
    }
  }
}

export const mockGatsbyImageDataTest = {
  layout: 'constrained' as const,
  width: 400,
  height: 400,
  images: {
    sources: [],
    fallback: {
      src: '/path/to/homer.png',
      srcSet: '/path/to/homer.png 400w',
      sizes: '(max-width: 400px) 100vw, 400px'
    }
  }
}

export const mockAdvancedGatsbyImageData = {
  layout: 'constrained' as const,
  width: 400,
  height: 400,
  images: {
    sources: [{
      srcSet: 'https://images.ctfassets.net/test-webp.webp 100w',
      sizes: '(min-width: 400px) 400px, 100vw',
      type: 'image/webp'
    }],
    fallback: {
      src: 'https://images.ctfassets.net/test-jpg.jpg',
      srcSet: 'https://images.ctfassets.net/test-jpg.jpg 100w',
      sizes: '(min-width: 400px) 400px, 100vw'
    }
  }
}

export const personMocks = [
  {
    jobTitle: 'Web Developer',
    firstName: 'Peter',
    lastName: 'Parker',
    region: 'North America',
    department: 'Business Relationship Management',
    phoneNumber: '1-646-000-0000 x3312',
    slug: "peter-parker",
    headshot: mockGatsbyImageData,
    email: 'xyz@fitchgroyp.com',
    analystTag: 'Tag 1',
    professional: 'Analyst'
  },
  {
    jobTitle: 'Senior Solutions Planner',
    firstName: 'Bruce',
    lastName: 'Wayne',
    region: 'North America',
    department: 'Business Relationship Management',
    phoneNumber: '1-312-000-0000 x69819',
    headshot: mockGatsbyImageData
  },
  {
    jobTitle: 'Product Functionality Officer',
    firstName: 'Stewie',
    lastName: 'Griffin',
    region: 'North America',
    department: 'Investors',
    phoneNumber: '(800) 000-0000 x19832',
    headshot: mockGatsbyImageData
  },
  {
    jobTitle: 'Lead Markets Orchestrator',
    firstName: 'Mayday',
    lastName: "Parker",
    region: 'North America',
    department: 'Business Relationship Management',
    phoneNumber: '300.000.0000 x8088',
    headshot: mockGatsbyImageData
  },
  {
    jobTitle: 'Dynamic Accounts Analyst',
    firstName: 'Jane',
    lastName: 'Doe',
    region: 'North America',
    department: 'Investors',
    phoneNumber: '200.000.0000 x1364',
    headshot: mockGatsbyImageData
  },
  {
    jobTitle: 'Chief Marketing Representative',
    firstName: 'Some',
    lastName: 'Guy',
    region: 'North America',
    department: 'Business Relationship Management',
    phoneNumber: '(444) 444-4444 x7091',
    headshot: mockGatsbyImageData
  },
  {
    jobTitle: 'Headshotless',
    firstName: 'Homer',
    lastName: 'Simpson',
    region: 'North America',
    department: 'Control Room',
    phoneNumber: '(000) 000-0000 x0',
  }
]

export const reducedPersonMocks = personMocks.map(item => {
  const newItem = { ...item }
  delete newItem.phoneNumber
  delete newItem.region
  return newItem
})
